/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { CreateMonitoringDto } from '../../models/create-monitoring-dto';
import { MonitoringItem } from '../../models/monitoring-item';

export interface MonitoringControllerCreate$Params {
      body: CreateMonitoringDto
}

export function monitoringControllerCreate(http: HttpClient, rootUrl: string, params: MonitoringControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MonitoringItem;
}>> {
  const rb = new RequestBuilder(rootUrl, monitoringControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: MonitoringItem;
      }>;
    })
  );
}

monitoringControllerCreate.PATH = '/monitoring';
